export const DIALOG_TITLE =
  "Welcome to the Nirva Member Directory Sign-Up Form";

export const BODY_TEXT =
  "This form allows you to submit the information needed to create your profile on the Nirva website.";

export const CRITERIA_SUBTITLE =
  "Please complete this form only if you meet the following criteria:";

export const PROFILE_SUBTITLE =
  "To complete your profile, please be prepared to provide the following:";

export const CANCEL_BTN_TEXT = "Cancel";

export const BEGIN_BTN_TEXT = "Click to begin";

export const CRITERIA_ITEMS = [
  "You are a graduate of the IIH in good standing.",
  "You are a current member of IAIH.",
  "You have a working website and are actively seeing clients.",
  "You have signed the IAIH Code of Ethics.",
  "You have a professional photo.",
];

export const PROFILE_ITEMS = [
  "Professional photo",
  "Biography",
  "Hypnotherapy specialties",
  "Experience",
  "Education",
  "Certifications",
  "Professional memberships",
  "Website URL",
  "Social media links",
  "Languages spoken",
  "Contact information",
];
